import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "lola-framework-ui-test";
import { AuraLayout } from "../components/AuraLayout";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";
import { useTerms } from "../hooks/useTerms";
import { TermsMarkdown } from "../components/terms/TermsMarkdown";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";
import { Navbar } from "../components/Navbar";


/**
 * Detail viewer for a single partner-configured Terms & Conditions entry.
 * The entry is resolved from the claimed session by `?entryId=`. Renders the
 * entry's markdown detail body.
 */
export const TermDetailPage = () => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { session } = useSessionStore();

  // Keep terms localized to the active UI language (English fallback).
  useTerms();

  const entryId = searchParams.get("entryId");
  const entry = session.data?.terms?.entries.find((e) => e.id === entryId);

  const title = entry?.detailTitle || t("terms.title");

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className="white-view-background term-detail-page"
    >
      <Layout.Header>
        <Navbar onBackClick={() => navigate(-1)} title={title} align="center" />
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="term-detail-wrapper foreground">
          {entry ? (
            <TermsMarkdown content={entry.detailMarkdown} />
          ) : (
            <p className="muted-foreground">{t("terms.notFound")}</p>
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
